import React, { useState, useContext, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";

// import ErrorMessage from "./ErrorMessage";
// import { useToken } from "../../context/useToken";
import { useToken } from "../../context/TokenContext";
import { UserContext } from "../../context/UserContext";
import './login.scss';
import Logo from '../../img/markitone_logo_cc.svg';
import * as backend_config from '../../config/backend'
import Dashboard from '../dashboard/dashboard';

import { useLanguage } from "../../context/TokenContext";


const Login = (props) => {
  let {langPack} = useLanguage();
  langPack = langPack["login"];

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [errorMessage, setErrorMessage] = useState("");
  // let langPack = require('frontend/src/lang/en.json')
  let history = useHistory();

  const {token, setToken} = useToken();
  // const {context} = useContext(UserContext);
  // const {token, setToken} = context.userToken;

  const [responseData, setResponseData] = useState({});
  // const {token, saveToken} = useContext(UserTokenContext);
  // const setToken = saveToken;

  useEffect(() => {
    return () => {};
  }, []);

  const submitLogin = async () => {
    let form = new FormData();
    form.append("username", username);
    form.append("password", password);

    const requestOptions = {
      method: "POST",
      headers: { 
       },
      body: form,
    };
    const response = await fetch(backend_config.BACKEND_URL_TOKEN, requestOptions);
    const data = await response.json();
    // setResponseData(data);


    if (response.ok) {
      // console.log(data);
      setToken(data.access_token);
      // console.log(token);
      history.push("/");
      // return <Redirect to="/" />
      // return <Dashboard/>
      // console.log('ok');
    }
    else{
      alert(langPack["Wrong username or password!"])
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitLogin();
  };
  

  return (
    <section id="login-page"> 
      <form id="loginForm" name='loginForm' onSubmit={handleSubmit}>
        <img src={Logo} alt='' className='logo'/>
        {/* <h2>
          Welcome!
        </h2> */}
        <fieldset>
          <legend>{langPack["Log In"]}</legend>
          <ul>
            <li>
              <label htmlFor="username">{langPack["Username / Email"]}:</label>
              <input 
                type="text" 
                id="username" 
                name="username"
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </li>
            <li>
              <label htmlFor="password">{langPack["Password"]}:</label>
              <input 
                type="password" 
                id="password" 
                name="password"
                onChange={(e) => setPassword(e.target.value)}
              required/>
            </li>
          </ul>
        </fieldset>
        <button type="submit">{langPack["Login"]}</button>
      </form>
    </section>
  );
};

export default Login;
